"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountsById = void 0;
const key_by_1 = require("../../helpers/key-by");
exports.accountsById = (state = {}, action = {}) => {
    switch (action.type) {
        case 'PROPERTY_ACCOUNT_CREATE_RECEIVE':
            return Object.assign(Object.assign({}, state), { [action.payload.account.id]: action.payload.account });
        case 'PROPERTY_GET_BY_ID_RECEIVE':
        case 'PROPERTY_CREATE_RECEIVE':
            return Object.assign(Object.assign({}, state), key_by_1.keyEntitiesBy(action.payload.property.accounts, 'id'));
        case 'PROPERTIES_BY_OWNER_RECEIVE':
            const allAccount = action.payload.properties.reduce((all, prop) => {
                return all.concat(prop.accounts || []);
            }, []);
            return Object.assign(Object.assign({}, state), key_by_1.keyEntitiesBy(allAccount, 'id'));
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map